import { Collapse, CollapseProps, Divider, Flex, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import { ContractorApiListSharedType } from '../../types';
import { UnshareDocumentButton } from './unshare-document-button';
import { useApi } from '../../api/useApi';
import { FolderOutlined } from '@ant-design/icons';
import { getListDataAfterShareItemsDelete } from './get-list-data-after-share-items-delete';
import { getRecipientContact } from './get-recipient-contact';

interface MySharedDocumentsTabByResourceProps {
    listData: ContractorApiListSharedType;
    setUpdateData: React.Dispatch<React.SetStateAction<boolean>>;
}

export const MySharedDocumentsTabByResource: React.FC<MySharedDocumentsTabByResourceProps> = ({
    listData,
    setUpdateData,
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [internalListData, setInternalListData] = useState<ContractorApiListSharedType>(listData);

    const api = useApi();

    useEffect(() => {
        setInternalListData(listData);
    }, [listData]);
    const storeRecipientByShareItem: Record<string, Set<string>> = {};

    internalListData.listShareItem.forEach((item) => {
        if (!storeRecipientByShareItem[item.id]) {
            storeRecipientByShareItem[item.id] = new Set();
        }

        storeRecipientByShareItem[item.id].add(item.rid);
    });

    const stopShare =
        (typeStop: 'recipient' | 'resource' | 'recipient-resource', recipientId?: string, resourceId?: string) =>
        async () => {
            setIsLoading(true);
            const result = await api.documents.stopShare({
                typeStop,
                recipientId,
                resourceId,
            });

            setUpdateData(true);

            console.log(result);

            const deletedListShareItem = recipientId
                ? internalListData.listShareItem.filter(
                      (shareItem) => shareItem.rid === recipientId && shareItem.id === resourceId,
                  )
                : internalListData.listShareItem.filter((shareItem) => shareItem.id === resourceId);

            setInternalListData(getListDataAfterShareItemsDelete(internalListData, deletedListShareItem));

            setIsLoading(false);
        };

    const getCollapseItem = (type: 'folder' | 'document', uuid: string, name: string) => ({
        key: uuid,
        label: (
            <Flex justify={'space-between'}>
                <Flex gap={10} align={'center'}>
                    {type === 'folder' && <FolderOutlined />}
                    {name}
                </Flex>
                <UnshareDocumentButton onClick={stopShare('resource', undefined, uuid)} />
            </Flex>
        ),
        children: (
            <>
                {internalListData.listRecipient
                    .filter((recipient) => storeRecipientByShareItem[uuid]?.has(recipient.id))
                    .map((recipient) => (
                        <Flex justify={'space-between'} style={{ margin: '2px 0', marginLeft: 24 }}>
                            {getRecipientContact(recipient)}
                            <UnshareDocumentButton onClick={stopShare('recipient-resource', recipient.id, uuid)} />
                        </Flex>
                    ))}
            </>
        ),
    });

    const itemsFolder: CollapseProps['items'] = internalListData.listFolder.map((folder) =>
        getCollapseItem('folder', folder.uuid, folder.name),
    );

    const itemsDocument: CollapseProps['items'] = internalListData.listDocument.map((document) =>
        getCollapseItem('document', document.id, document.name),
    );

    const getDivider = (caption: string) => (
        <Divider size={'small'} orientation="left" style={{ fontSize: 12, fontWeight: 600 }}>
            {caption}
        </Divider>
    );

    return (
        <Spin spinning={isLoading}>
            {!!itemsFolder.length && (
                <>
                    {getDivider('Folders')}
                    <Collapse ghost items={itemsFolder} />
                </>
            )}
            {!!itemsDocument.length && (
                <>
                    {getDivider('Documents')}
                    <Collapse ghost items={itemsDocument} />
                </>
            )}
        </Spin>
    );
};
